import React from 'react';

import { DataTable, DataTableRow, Skeleton, DataTableHead } from '@flixbus/honeycomb-react';

const TableLoader = () => {
	return (
		<DataTable
			headers={
				<DataTableHead>
					<th style={{ width: '20%' }} scope="col">
						Group Name
					</th>
					<th scope="col">Members</th>
					<th scope="col">Description</th>
					<th scope="col">Created by</th>
					<th scope="col" />
				</DataTableHead>
			}
		>
			<DataTableRow>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td style={{ textAlign: 'center' }}>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
				</td>
			</DataTableRow>
			<DataTableRow>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td style={{ textAlign: 'center' }}>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
				</td>
			</DataTableRow>
			<DataTableRow>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td style={{ textAlign: 'center' }}>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
				</td>
			</DataTableRow>
			<DataTableRow>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td style={{ textAlign: 'center' }}>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
				</td>
			</DataTableRow>
			<DataTableRow>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td style={{ textAlign: 'center' }}>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton width="lg" height="md" />
				</td>
				<td>
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
					<Skeleton inline width="xs" height="md" />
				</td>
			</DataTableRow>
		</DataTable>
	);
};

export default TableLoader;
